const autoResizeInput = {
	
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();
		const that = this;
		this.ui.$autoResizeInput.each(function(){
			that.setSizeFromInput($(this));
		});
	},

	bindUI: function() {
		this.ui.$autoResizeInput = $('.js-autoResizeInput');
	},

	bindEvents: function() {
		this.ui.$autoResizeInput.on('input', this.resizeInput.bind(this));
	},

	resizeInput: function(e) {
		var $this = $(e.currentTarget);
		this.setSizeFromInput($this);
	},
	setSizeFromInput: function($input){
		// soucis avec le fait que ça sois pas une typo monospace 
		// ch => largeur du "0", ici le "l" est moins lrage que le 0 par exemple, ce qui fausse le calcul
		// possible amélioration en ajoutant une div invisible contenant la chaine et dont on récupère la vrai width ?
		if($input.val().length > 0 ){
  			$input.css({'width': $input.val().length + "ch"});
		}else{
  			$input.css({'width': $input.attr("placeholder").length + "ch"});			
		}
	}
};

module.exports = autoResizeInput;